import { Box, Typography, Grid, Paper, Stack } from "@mui/material";
import { PenaltyLog } from "../../../../types/LogTypes";
import { jerseyNumberNameDisplay } from "../../../../helpers/helpers";

interface PenaltyLogDetailsProps {
    penalties: PenaltyLog[];
}

export const PenaltyLogDetails: React.FC<PenaltyLogDetailsProps> = ({penalties}) => {

    if (penalties.length === 0) {
        return null;
    }
    
    return (
        <Paper
            elevation={2}
            sx={{
              p: 3,
              height: "100%",
              backgroundColor: "background.paper",
              borderRadius: 2,
            }}
          >
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Penalties
            </Typography>
            <Stack spacing={2}>
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  Penalty
                </Typography>
                <Typography variant="h6">
                  {penalties[0].penalty?.name || ""}
                </Typography>
              </Box>
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  Penalty Yards
                </Typography>
                <Typography variant="h6">
                  {penalties[0].penalty?.yards || ""}
                </Typography>
              </Box>
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  Player
                </Typography>
                <Typography variant="h6">
                  {penalties[0].roster_player
                    ? jerseyNumberNameDisplay(penalties[0].roster_player)
                    : "N/A"}
                </Typography>
              </Box>
            </Stack>
          </Paper>
    );
};